import { alpha, ListItem, ListItemButton, useTheme } from "@mui/material";
import { Conversation } from "../types/queries";
import { PropsWithChildren } from "react";
import { useAppSelector } from "../../../app/hooks";
import { selectSelectedConversationId } from "../messagingSlice";
import { isSystemMessage } from "../helpers";

type Props = {
  conversation: Conversation;
  onChange: (conversation: Conversation) => void;
};

const InboxRowListItem = ({
  conversation,
  onChange,
  children,
}: PropsWithChildren<Props>) => {
  const theme = useTheme();
  const selectedConversationId = useAppSelector(selectSelectedConversationId);

  const systemMessageStyles = isSystemMessage(conversation.initiator)
    ? {
        backgroundColor: alpha(theme.palette.error.main, 0.2),
        border: `1px solid ${theme.palette.error.main}`,
      }
    : {};

  return (
    <ListItem
      key={conversation.id}
      disablePadding
      sx={{
        borderRadius: "4px",
        marginBottom: "2px",
        minHeight: "80px",
        height: "auto",
        width: "100%",
        overflow: "visible",
        ...systemMessageStyles,
      }}
    >
      <ListItemButton
        selected={selectedConversationId === conversation.id}
        onClick={() => onChange(conversation)}
        sx={{
          minHeight: "80px",
          height: "auto",
          display: "flex",
          alignItems: "center",
          overflow: "visible",
        }}
      >
        {children}
      </ListItemButton>
    </ListItem>
  );
};

export default InboxRowListItem;
